export const EVENT_BUS = {
  FIELDS: "fields",
  DIALOG_ERR: "dialog-err",
  SNACKBAR: 'snackbar',
};

export const DEFAULT_PAGINATION = {
  PAGE: 1,
  SIZE: 50
}

export const DEFAULT_LIMIT_PAGINATION = {
  LIMIT: 30,
  OFFSET: 0
}

export const DATE_FORMAT_DEFAULT = 'DD-MM-YYYY'
export const DATE_FORMAT_DEFAULT_DDD = 'DD-MM-YYYY dd'
export const DATE_FORMAT_HOUR_DEFAULT = 'DD-MM-YYYY HH:mm'
export const DATE_FORMAT_HOUR_SECONDS_DEFAULT = 'DD-MM-YYYY HH:mm:ss'
export const HOUR_FORMAT_DEFAULT = 'HH:mm'
export const DATE_DEFAULT_REGXP = /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/
export const DATE_INDIAN_REGXP = /^(((0*[1-9]|[12][0-9]|3[01])([-])(0*[13578]|10|12)([-])(\d{4}))|((0*[1-9]|[12][0-9]|30)([-])(0*[469]|11)([-])(\d{4}))|((0*[1-9]|1[0-9]|2[0-8])([-])(02|2)([-])(\d{4}))|((29)(\.|-|\/)(02|2)([-])([02468][048]00))|((29)([-])(02|2)([-.-])([13579][26]00))|((29)([-])(02|2)([-])([0-9][0-9][0][48]))|((29)([-])(02|2)([-])([0-9][0-9][2468][048]))|((29)([-])(02|2)([-])([0-9][0-9][13579][26])))/
export const HOUR_DEFAULT_REGXP = /[0-9][0-9][:][0-9][0-9]/
export const DATE_FORMAT_CRM_BACKEND = 'YYYY-MM-DD'


export const LOG_STATUS = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error'
}

export const LOG_PAGE = {
  ACCEPTANCE: 'acceptance',
  RESERVATIONS: 'reservations',
  EXAM_RESULTS: 'exam_results',
  IMPORT_TOP_CBR: 'import_top_cbr',
  MIJN_CBR_SLOTS: 'mijn_cbr_slots',
  TOP_CBR_SLOTS: 'top_cbr_slots',
  CONTANCT: 'candidate_contact'
}

export const PRODUCT = {
  BTH: 'BTH',
  BTH_VE: 'BTH-VE'
}

export const PRODUCT_OPTIONS = [
  PRODUCT.BTH,
  PRODUCT.BTH_VE
]

export const DRAWER_WIDTH = 220

export const DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday','Thursday' , 'Friday' , 'Saturday']
export const DOW_DUTCH = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag','Donderdag' , 'Vrijdag' , 'Zaterdag']
export const DOW_DUTCH_DDD = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']
export const DOW_BACKEND = ['','Monday', 'Tuesday', 'Wednesday','Thursday' , 'Friday' , 'Saturday' ,'Sunday']
export const DOW_BACKEND_ITEM_KEY = [
  {
    key: 2,
    label: 'Monday'
  },
  {
    key: 3,
    label: 'Tuesday'
  },
  {
    key: 4,
    label: 'Wednesday'
  },
  {
    key: 5,
    label: 'Thursday'
  },
  {
    key: 6,
    label: 'Friday'
  },
  {
    key: 7,
    label: 'Saturday'
  },
  {
    key: 0,
    label: 'Sunday'
  },
]

const monthMap = {
  0: 'Januari',
  1: 'Februari',
  2: 'Maart',
  3: 'April',
  4: 'Mei',
  5: 'Juni',
  6: 'Juli',
  7: 'Augustus',
  8: 'September',
  9: 'Oktober',
  10: 'November',
  11: 'December'
}

export const MONTH_DUTCH = [
  'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 
  'Augustus', 'September', 'Oktober', 'November', 'December'
]

export const CRM_PERMS = {
  CANDIDATES: 'CANDIDATES',
  RESULTS: 'RESULTS',
  SLOTS:'SLOTS',
  RESERVED_EXAMS: 'RESERVED_EXAMS',
  CBR_ACCOUNTS: 'CBR_ACCOUNTS',
  COURSE_MANAGMENT: 'COURSE_MANAGEMENT',
  DRIVING_SCHOOLS: 'DRIVING_SCHOOLS'
}

export const VIEWPORTS = {
  DEFAULT: 'width=device-width, initial-scale=1.0',
  SCALED: 'width=1024, initial-scale=1.0',
  SCALED_IOS: 'width=1024, initial-scale=0.5, height=device-height, viewport-fit=cover',
}

export const STORAGE = {
  SUGGEST: {
    EXAM: {
      CONTENT: 'suggest_exam_content',
      SUBJECT: 'suggest_exam_subject'
    },
    EXCHANGE: {
      CONTENT: 'suggest_exchange_content',
      SUBJECT: 'suggest_exchange_subject'
    },
    MIJN: {
      CONTENT: 'suggest_mijn_content',
      SUBJECT: 'suggest_mijn_subject',
    }
  }
}